import { lang } from "../core/variables-global.js";

let UIHelper = () =>  {
  //const lang = document.documentElement.lang || "fr";
  const displayErrorMessage = (message, statusMessageElement) => {
    const statusMessage = statusMessageElement || document.querySelector(".js-status-message");
    statusMessage.className = "status-message js-status-message error";

    const errorHTML = `<p class="message-erreur" tabindex="-1" id="error-1">
            <svg class="hq-icone-medium" aria-label="alerte" role="img">
                <use href="/@hydroquebec/assets/dist/icones/sprite.svg#hq-icone-danger-plein"></use>
            </svg>
            ${message}
        </p>`;

    statusMessage.innerHTML = errorHTML;

    const errorElement = statusMessage.querySelector(".message-erreur");
    if (errorElement) {
      errorElement.focus();
    }
  };

  /**
   * Affiche ou masque le spinner global avec overlay et désactivation complète des interactions
   */
  const showGlobalLoading = (show, message = lang === "en" ? "Loading..." : "Chargement en cours...") => {
    let overlay = document.getElementById("global-loading-overlay");

    // Si l'overlay n'existe pas encore, utiliser le placeholder ou en créer un
    if (!overlay) {
      overlay = document.getElementById("global-loading-overlay-placeholder");
      if (overlay) {
        overlay.id = "global-loading-overlay";
        overlay.classList.remove("hidden");
      }
    }

    if (!overlay) return;

    const loadingText = overlay.querySelector(".global-loading-text");

    if (show) {
      if (loadingText) {
        loadingText.textContent = message;
      }

      // Afficher l'overlay
      overlay.classList.remove("hidden");
      overlay.setAttribute("aria-hidden", "false");

      // Désactiver le scroll sur toute la page
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";

      // Désactiver les interactions sur tous les éléments interactifs
      disableAllInteractions();

      // Annoncer aux lecteurs d'écran
      announceLoadingState(true, message);

    } else {
      // Masquer l'overlay
      overlay.classList.add("hidden");
      overlay.setAttribute("aria-hidden", "true");

      // Réactiver le scroll
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";

      // Réactiver les interactions
      enableAllInteractions();

      // Annoncer la fin du chargement
      announceLoadingState(false);
    }
  };

  /**
   * Désactive toutes les interactions (clics, navigation clavier, etc.)
   */
  const disableAllInteractions = () => {
    // Empêcher les clics sur tous les éléments
    document.addEventListener("click", preventInteraction, true);
    document.addEventListener("mousedown", preventInteraction, true);
    document.addEventListener("mouseup", preventInteraction, true);

    // Empêcher la navigation clavier
    document.addEventListener("keydown", preventKeyboardNavigation, true);
    document.addEventListener("keyup", preventInteraction, true);

    // Empêcher le scroll avec la molette
    document.addEventListener("wheel", preventInteraction, { passive: false, capture: true });
    document.addEventListener("touchmove", preventInteraction, { passive: false, capture: true });

    // Empêcher les événements de formulaire
    document.addEventListener("submit", preventInteraction, true);
    document.addEventListener("focus", preventFocusOutsideOverlay, true);

    // Marquer que les interactions sont désactivées
    document.body.setAttribute("data-interactions-disabled", "true");
  };

  /**
   * Réactive toutes les interactions
   */
  const enableAllInteractions = () => {
    // Retirer tous les event listeners
    document.removeEventListener("click", preventInteraction, true);
    document.removeEventListener("mousedown", preventInteraction, true);
    document.removeEventListener("mouseup", preventInteraction, true);
    document.removeEventListener("keydown", preventKeyboardNavigation, true);
    document.removeEventListener("keyup", preventInteraction, true);
    document.removeEventListener("wheel", preventInteraction, true);
    document.removeEventListener("touchmove", preventInteraction, true);
    document.removeEventListener("submit", preventInteraction, true);
    document.removeEventListener("focus", preventFocusOutsideOverlay, true);

    // Marquer que les interactions sont réactivées
    document.body.removeAttribute("data-interactions-disabled");
  };

  /**
   * Empêche les interactions non autorisées
   */
  const preventInteraction = (event) => {
    const overlay = document.getElementById("global-loading-overlay");

    // Si l'overlay n'est pas visible, ne pas bloquer
    if (!overlay || overlay.classList.contains("hidden")) {
      return;
    }

    // Autoriser les interactions dans l'overlay lui-même
    if (overlay.contains(event.target)) {
      return;
    }

    // Bloquer toutes les autres interactions
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  };

  /**
   * Empêche la navigation clavier non autorisée
   */
  const preventKeyboardNavigation = (event) => {
    const overlay = document.getElementById("global-loading-overlay");

    // Si l'overlay n'est pas visible, ne pas bloquer
    if (!overlay || overlay.classList.contains("hidden")) {
      return;
    }

    // Autoriser Escape pour l'accessibilité (même si on ne ferme pas le loading)
    if (event.key === "Escape") {
      return;
    }

    // Autoriser les interactions dans l'overlay
    if (overlay.contains(event.target)) {
      return;
    }

    // Bloquer Tab, Enter, Espace et les flèches
    const blockedKeys = ["Tab", "Enter", " ", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
    if (blockedKeys.includes(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  };

  /**
   * Empêche le focus en dehors de l'overlay
   */
  const preventFocusOutsideOverlay = (event) => {
    const overlay = document.getElementById("global-loading-overlay");

    // Si l'overlay n'est pas visible, ne pas bloquer
    if (!overlay || overlay.classList.contains("hidden")) {
      return;
    }

    // Si le focus tente d'aller en dehors de l'overlay, le rediriger vers l'overlay
    if (!overlay.contains(event.target)) {
      event.preventDefault();
      const loadingText = overlay.querySelector(".global-loading-text");
      if (loadingText) {
        loadingText.focus();
      }
    }
  };

  /**
   * Annonce l'état de chargement aux lecteurs d'écran
   */
  const announceLoadingState = (isLoading, message = "") => {
    // Créer ou trouver la région live pour les annonces
    let announcer = document.getElementById("loading-announcer");
    if (!announcer) {
      announcer = document.createElement("div");
      announcer.id = "loading-announcer";
      announcer.setAttribute("aria-live", "assertive");
      announcer.setAttribute("aria-atomic", "true");
      announcer.className = "sr-only";
      document.body.appendChild(announcer);
    }

    if (isLoading) {
      const loadingMessage = `${message}. Navigation et interactions temporairement désactivées pendant le chargement.`;
      announcer.textContent = loadingMessage;
    } else {
      announcer.textContent = "Chargement terminé. Navigation et interactions rétablies.";

      // Supprimer le message après un délai
      setTimeout(() => {
        announcer.textContent = "";
      }, 2000);
    }
  };

  /**
   * Désactive ou réactive les éléments de formulaire pendant le chargement
   */
  const setElementsDisabled = (elements, disabled) => {
    if (!Array.isArray(elements)) {
      elements = [elements];
    }

    elements.forEach(el => {
      if (!el) return;

      if (disabled) {
        el.setAttribute("disabled", "true");
        el.setAttribute("aria-disabled", "true");
      } else {
        el.removeAttribute("disabled");
        el.removeAttribute("aria-disabled");

        // S'assurer que l'élément est visuellement réactivé
        if (el.style) {
          el.style.opacity = "";
        }
      }
    });
  };

  const displayBandeauErrorMessage = ({message}) => {
    //Alerte bandeau-default
    //const blocRechercheAvancee = document.querySelector(".js-bloc-recherche-avancee");
    //blocRechercheAvancee.classList.add("status-disabled");

    const bandeauMessageEl = document.querySelector(".js-bandeau-message-alerte");
    const bandeauMessageTitreEl = document.querySelector(".js-message-alerte");
    bandeauMessageTitreEl.textContent = message.title;
    bandeauMessageEl.classList.remove("hidden");
  }

  return {
    displayErrorMessage,
    showGlobalLoading,
    setElementsDisabled,
    displayBandeauErrorMessage
  };
};

UIHelper = UIHelper();
export default UIHelper;
